<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{ name: 'dashboard' }"
                                    >Portada</router-link
                                >
                            </li>
                            <li>
                                <span>Usuarios</span>
                            </li>
                            <li class="active">
                                <span>Lista de usuarios</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        Lista de usuarios
                    </h2>
                    <small>Gestionar usuarios</small>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Usuarios
                </div>
                <div class="panel-body">
                    <div class="m-b-md">
                        <div class="m-b-sm">
                            <button
                                class="btn btn-default"
                                type="button"
                                data-toggle="collapse"
                                data-target="#userListFilters"
                                aria-expanded="false"
                                @click="toggleFilter"
                                aria-controls="userListFilters"
                            >
                                Filtros
                                <i
                                    :class="
                                        'fa fa-caret-' +
                                            (filterFlag ? 'down' : 'up')
                                    "
                                ></i>
                            </button>
                            <router-link
                                class="btn btn-primary btn-outline pull-right"
                                tag="button"
                                :to="userNewRoute"
                            >
                                Crear
                                <i class="fa fa-plus"></i
                            ></router-link>
                        </div>
                        <div class="collapse" id="userListFilters">
                            <div class="form">
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <label>Nombre</label>
                                        <custom-input
                                            tipo="text"
                                            :field="$v.filters.name"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Correo electrónico</label>
                                        <custom-input
                                            tipo="text"
                                            :field="$v.filters.email"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Hotel</label>
                                        <custom-input
                                            tipo="select"
                                            :field="$v.filters.hotel"
                                            :items="hotels"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Estado</label>
                                        <custom-input
                                            tipo="select"
                                            :field="$v.filters.status"
                                            :items="statuses"
                                        />
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                            @click="clear"
                                        >
                                            Limpiar filtros
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            @click="search"
                                        >
                                            Aplicar filtros
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table
                            cellpadding="1"
                            cellspacing="1"
                            class="table table-bordered table-striped"
                        >
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Celular</th>
                                    <th>Correo electrónico</th>
                                    <th>Usuario</th>
                                    <th>Perfil</th>
                                    <th>Hotel</th>
                                    <th>Estado</th>
                                    <th style="width:6%">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="o in data" :key="o.id">
                                    <td>
                                        <span>{{ o.name }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.phone }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.email }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.username }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{
                                            getProfileDesc(o.profile)
                                        }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{
                                            o.hotel ? o.hotel.name : null
                                        }}</span>
                                    </td>
                                    <td align="center">
                                        <status-badge :status="o.status" />
                                    </td>
                                    <td align="center" class="action-cell">
                                        <div class="dropdown">
                                            <a
                                                type="button"
                                                class="dropdown-toggle"
                                                data-toggle="dropdown"
                                                ><i class="fa fa-gear"></i
                                            ></a>
                                            <ul
                                                class="dropdown-menu filedropdown m-l pull-right"
                                            >
                                                <li>
                                                    <a @click="goToEdit(o.id)"
                                                        >EDITAR</a
                                                    >
                                                </li>
                                                <li>
                                                    <a
                                                        @click="
                                                            toggleUserState(
                                                                o.id,
                                                                o.status
                                                            )
                                                        "
                                                        >{{
                                                            o.status === 1
                                                                ? "INACTIVAR"
                                                                : "ACTIVAR"
                                                        }}</a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <paginator
                        :total-elements="totalElements"
                        :page-number="pageNumber"
                        :total-pages="totalPages"
                        :change-page="changePage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { USER_EDIT, USER_LIST, USER_NEW } from "../../router/routes";
import CustomInput from "../common/CustomInput.vue";
import StatusBadge from "../common/StatusBadge.vue";
import { email, maxLength } from "vuelidate/lib/validators";
import { userStatusList, profileList } from "../../util/selectOptions";
import UserService from "../../services/UserService";
import HotelService from "../../services/HotelService";
import { paginationMixin } from "../../util/paginationMixin";
import { filterMixin } from "../../util/filterMixin";
import Alert from "../../util/alert";

export default {
    name: USER_LIST.name,
    mixins: [paginationMixin, filterMixin],
    components: { CustomInput, StatusBadge },
    data: () => ({
        userNewRoute: USER_NEW.route,
        data: [],
        hotels: [],
        statuses: userStatusList,
        profiles: profileList,
        filters: {
            name: null,
            email: null,
            hotel: null,
            status: null
        }
    }),
    validations: {
        filters: {
            name: { maxLength: maxLength(100) },
            email: { email, maxLength: maxLength(45) },
            hotel: {},
            status: {}
        }
    },
    methods: {
        async init() {
            const self = this;

            let activeState = {
                key: 1,
                value: "ACTIVO"
            };

            self.filters.status = activeState;
            await self.getData({ status: activeState.key });

            this.hotels = [];
            const hotelsData = (await HotelService.listAllHotels()).data
                .payload;
            hotelsData.forEach(it => {
                self.hotels.push({ key: it.id, value: it.name });
            });
        },
        getProfileDesc(profile) {
            return this.profiles.filter(prof => {
                return prof.key === profile;
            })[0].value;
        },
        search() {
            this.$v.$touch();
            if (this.$v.$error) return;
            const self = this;

            const data = {
                ...self.filters,
                ...{
                    status: self.filters.status
                        ? self.filters.status.key
                        : null,
                    hotelId: self.filters.hotel ? self.filters.hotel.key : null
                }
            };
            self.getData(data);
        },
        clear() {
            const self = this;
            self.filters.name = self.filters.email = self.filters.status = self.filters.hotel = null;
            self.$v.$reset();
        },
        goToEdit(userId) {
            this.$router.push({
                path: USER_EDIT.route.replace(":userId", userId)
            });
        },
        onToggleState(user) {
            const self = this;
            const users = self.data.filter(o => {
                return o.id === user.id;
            });
            const userFiltered = users && users.length > 0 ? users[0] : null;
            const index = self.data.indexOf(userFiltered);
            self.$set(self.data, index, user);
        },
        async toggleUserState(userId, source) {
            try {
                const status = source === 1 ? 2 : 1;
                const userUpdated = (
                    await UserService.toggleUserState(userId, status)
                ).data.payload;
                this.onToggleState(userUpdated);
            } catch (err) {
                Alert.mensajeError(err.message);
            }
        },
        async getData(params = {}, page = 1) {
            const self = this;
            params.page = page - 1;
            params.size = self.pageSize;
            self.params = params;
            self.loading = true;
            const payload = (await UserService.filterUsers(params)).data
                .payload;
            self.data = payload.content;
            self.totalPages = payload.totalPages;
            self.totalElements = payload.totalElements;
            self.pageNumber = payload.number + 1;
            self.loading = false;
        }
    },
    async mounted() {
        this.init();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/user/UserList.vue